export const MAP_CONTEXTS = {
  S: 'substances',
  R: 'reactions',
  C: 'citations',
  T: 'tgitems',
  D: 'dpitems',
};

export const typeOfHopintoInvalidParamsDialog = 'typeOfHopintoInvalidParamsDialog';

export class StructureFormats {
  static SMILES = 'SMILES';

  static MOLFILE = 'MOLFILE';
}

export const invalidParamsMessage =
  'Invalid target molecule. Please check the syntax: the context RT requires either a SMILES or Molfile as query';
